import { CompanySidePeekHeader } from '@/components/custom/companies/company-side-peek-header'
import { ContactsSection } from '@/components/custom/companies/contacts-section'
import { GovernanceSection } from '@/components/custom/companies/governance-section'
import { InvestmentSection } from '@/components/custom/companies/investment-section'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
} from '@/components/ui/sheet'
import { cn } from '@/lib/utils'
import type { Company } from '@/types/api'

export const SIDE_PANEL_WIDTH = 'w-[360px]'

interface CompanySidePanelProps {
  company: Company
  onRefresh: () => void
}

interface CompanySidePanelSheetProps {
  company: Company
  onRefresh: () => void
  open: boolean
  onOpenChange: (open: boolean) => void
}

function CompanySidePanelSections({
  company,
  onRefresh,
}: CompanySidePanelProps) {
  return (
    <div className="space-y-3">
      <CompanySidePeekHeader company={company} mode="overview" />
      <InvestmentSection company={company} />
      <GovernanceSection company={company} onUpdate={onRefresh} />
      <ContactsSection company={company} onUpdate={onRefresh} />
    </div>
  )
}

export function CompanySidePanel({
  company,
  onRefresh,
}: CompanySidePanelProps) {
  return (
    <div
      className={cn(
        SIDE_PANEL_WIDTH,
        'h-full shrink-0 border-l border-primary/50 bg-sidebar px-3 py-6'
      )}
    >
      <CompanySidePanelSections company={company} onRefresh={onRefresh} />
    </div>
  )
}

export function CompanySidePanelSheet({
  company,
  onRefresh,
  open,
  onOpenChange,
}: CompanySidePanelSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-[min(92vw,420px)] overflow-y-auto bg-sidebar p-0 sm:max-w-none"
      >
        <SheetTitle className="sr-only">Company details</SheetTitle>
        <SheetDescription className="sr-only">
          Company profile, investment, governance, and contacts
        </SheetDescription>
        <div className="px-3 py-4">
          <CompanySidePanelSections company={company} onRefresh={onRefresh} />
        </div>
      </SheetContent>
    </Sheet>
  )
}
